import { Box, Modal, Paper } from "@mui/material";
import React, { ReactNode } from "react";

export const ModalWindow: React.FC<{
  children: ReactNode;
  open?: boolean;
}> = ({ children, open = false }) => {
  return (
    <Modal open={open}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
        }}
      >
        <Paper
          elevation={7}
          sx={{
            padding: "2rem",
            width: "40rem",
            gap: 2,
            display: "flex",
            flexDirection: "column",
          }}
        >
          {children}
        </Paper>
      </Box>
    </Modal>
  );
};
